import { CurrentSong as SongType } from '@yleisradio/areena-types';
import React from 'react';
import { getCurrentSongForChannel } from 'services/areena-api/fetchers';
import useSWR from 'swr';
import styles from './CurrentSong.module.scss';
import { Time } from 'components/Time';
import classNames from 'classnames';
import { useTranslation } from 'hooks/useTranslation';
import { DSNotification } from 'components/DSNotification';

type RequestKey = ['song', channelId: string];

async function fetcher([, channelId]: RequestKey): Promise<SongType | null> {
  return getCurrentSongForChannel(channelId);
}

type Props = {
  channelId: string;
  isParentLoading: boolean;
};

export const CurrentSong: React.FC<Props> = ({
  channelId,
  isParentLoading,
}) => {
  const t = useTranslation();

  const {
    data: song,
    error: songError,
    isLoading: isSongLoading,
  } = useSWR(['song', channelId] satisfies RequestKey, fetcher, {
    refreshInterval: 60_000,
    revalidateOnFocus: true,
  });

  const isLoading = isParentLoading || isSongLoading;
  const { performer, title, startTime } = song || {};

  if (songError)
    return (
      <DSNotification
        type="error"
        state="primary"
        title={t('genericError')}
        subtitle={t('songFetchError')}
      />
    );

  if (!title && !isLoading) return null;

  if (isLoading)
    return <div className={classNames(styles.root, styles.loading)} />;

  return (
    <div className={styles.root}>
      <div className={styles.nowPlaying}>{t('nowPlaying')}</div>
      <Time date={startTime} />
      {' '}
      {performer}
      {performer && ' - '}
      {title}
    </div>
  );
};
